import React from "react";
import styled from "@emotion/styled";
import mediaqueries from "@styles/media";

import FooterLinksSection from "@components/Navigation/Navigation.Footer.Links.List";

const Links: React.FC<{}> = () => {
  const baseUrl = 'https://get-base.com';
  const baseLinksSectionData = [
    { text: 'About', href: `${baseUrl}/about`},
    { text: 'Our science', href: `${baseUrl}/science`},
    { text: 'Custom Program', href: `${baseUrl}/quiz`},
    { text: 'Gifting', href: `${baseUrl}/gifts`},
    { text: 'Reviews', href: `${baseUrl}/reviews`}
  ];
  const businessLinksSectionData = [
    { text: 'Providers', href: `${baseUrl}/providers/home`},
    { text: 'Employers', href: `${baseUrl}/business`},
    { text: 'Affiliates', href: `${baseUrl}/affiliate-program`}
  ];
  const helpLinksSectionData = [
    { text: 'Contact', href: `mailto:info@get-base.com`},
    { text: 'Help Center', href: 'https://help.get-base.com/en/'},
    { text: 'Terms & Conditions', href: `${baseUrl}/terms`},
    { text: 'Privacy Policy', href: `${baseUrl}/privacy-policy`}
  ];
  const blogLinksSectionData = [
    { text: 'The Daily Dose', href: `${baseUrl}/blog/`},
    { text: 'Not eating & bloated?', href: `${baseUrl}/blog/bloated-from-not-eating/`},
    { text: 'Boost libido with vitamin D', href: `${baseUrl}/blog/vitamin-d-libido/`},
    { text: 'Hormone-balancing foods', href: `${baseUrl}/blog/hormone-balancing-foods/`},
  ];
  return (
    <>
      <FooterLinksContainer>
        <FooterLinksContainerDesktop>
          <FooterLinksSection title="Base" linksData={baseLinksSectionData} />
          <FooterLinksSection title="For Business" linksData={businessLinksSectionData} />
          <FooterLinksSection title="Help" linksData={helpLinksSectionData} />
          <FooterLinksSection title="Base" linksData={blogLinksSectionData} />
        </FooterLinksContainerDesktop>
        <FooterLinksContainerMobile>
          <FooterLinksSection title="Base" linksData={baseLinksSectionData} />
          <FooterLinksSection title="For Business" linksData={businessLinksSectionData} />
          <FooterLinksSection title="Help" linksData={helpLinksSectionData} />
          <FooterLinksSection title="Base" linksData={blogLinksSectionData} />
        </FooterLinksContainerMobile>
      </FooterLinksContainer>
    </>
  );
};

const FooterLinksContainer = styled.div`
  display: flex;
  
  ${mediaqueries.tablet`
    padding-left: 16px;
  `}
`;

const FooterLinksContainerDesktop = styled.div`
  display: flex;
  
  ${mediaqueries.tablet`
    display: none;
  `}
`;

const FooterLinksContainerMobile = styled.div`
  display: none;
  
  ${mediaqueries.tablet`
    display: flex;
    flex-direction: column;
  `}
  ${mediaqueries.phablet`
    display: grid;
    grid-row: auto;
    grid-template-columns: 150px 150px;
  `}
`;

export default Links;
